import { render, staticRenderFns } from "./MobileZhuanjxq.vue?vue&type=template&id=04dc0917"
import script from "./MobileZhuanjxq.vue?vue&type=script&lang=js"
export * from "./MobileZhuanjxq.vue?vue&type=script&lang=js"
import style0 from "./MobileZhuanjxq.vue?vue&type=style&index=0&id=04dc0917&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.22_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_4o2rd25vzlqqqsloupejyolan4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports